import { CommonModule } from '@angular/common';
import { ModuleWithProviders, NgModule } from '@angular/core';
import { HistoryFacade } from './+state';
import { HistoryStateModule } from './+state/history.state.module';

import {
  HistoryService
} from './services';

@NgModule({
  imports: [CommonModule, HistoryStateModule],
})
export class DomainHistoryModule {
  public static forRoot(): ModuleWithProviders {
    return {
      ngModule: DomainHistoryModule,
      providers: [
        HistoryService,
        HistoryFacade
      ],
    };
  }
}
